import { FC, FormEvent, useEffect } from 'react'
import { Field } from 'formik'
import styles from './index.module.scss'
import { CurrencyUnit } from '../../../types'
import { InputFieldGroup } from '../InputFieldGroup'
import { encodeToStringWithCommas, getCurrencySymbol } from '../../../utils'

type Props = {
  currencyUnit: CurrencyUnit
  minAmount: string
  maxAmount: string
  minAmountName: string
  maxAmountName: string
  setFieldMinValue: (value: string) => void
  setFieldMaxValue: (value: string) => void
}

export const AmountTextField: FC<Props> = ({
  currencyUnit,
  minAmount,
  maxAmount,
  minAmountName,
  maxAmountName,
  setFieldMinValue,
  setFieldMaxValue,
}) => {
  const changeValue = (name: string, value: string) => {
    const valueWithCommas = encodeToStringWithCommas(value)
    if (name === minAmountName) {
      setFieldMinValue(valueWithCommas)
    } else if (name === maxAmountName) {
      setFieldMaxValue(valueWithCommas)
    }
  }

  const onChange = (e: FormEvent<HTMLInputElement>) => {
    const { name, value } = e.currentTarget
    changeValue(name, value)
  }

  useEffect(() => {
    changeValue(minAmountName, minAmount)
    changeValue(maxAmountName, maxAmount)
  }, [])

  return (
    <div className={styles.container}>
      <span>{getCurrencySymbol(currencyUnit)}</span>
      <Field
        name={minAmountName}
        type='text'
        fieldType='setting'
        component={InputFieldGroup}
        customChangeHandler={onChange}
      />
      <span className={styles.line}>〜</span>
      <span>{getCurrencySymbol(currencyUnit)}</span>
      <Field
        name={maxAmountName}
        type='text'
        fieldType='setting'
        component={InputFieldGroup}
        customChangeHandler={onChange}
      />
    </div>
  )
}
